import axios from 'axios';

// Prod : chaîne vide = même origine (ex. reverse proxy /api vers uvicorn).
const raw = process.env.REACT_APP_BACKEND_URL;
const BACKEND_URL =
  raw === undefined || raw === null || String(raw).trim() === ''
    ? ''
    : String(raw).replace(/\/$/, '');
const API_BASE = BACKEND_URL ? `${BACKEND_URL}/api` : '/api';

// Get auth token from localStorage
const getAuthHeaders = () => {
  const token = localStorage.getItem('adminToken');
  return token ? { Authorization: `Bearer ${token}`, 'X-Admin-Token': token } : {};
};

// Public endpoints
export const api = {
  // Site data
  getSiteData: () => axios.get(`${API_BASE}/site-data`),
  
  // Projects
  getProjects: () => axios.get(`${API_BASE}/projects`),
  
  // Services
  getServices: () => axios.get(`${API_BASE}/services`),
  
  // Pricing
  getPricing: () => axios.get(`${API_BASE}/pricing`),
  
  // Contact
  submitContact: (data) => axios.post(`${API_BASE}/contact`, data),
};

// Admin endpoints
export const adminApi = {
  // Auth
  login: (username, password) => axios.post(`${API_BASE}/admin/login`, { username, password }),
  
  // Site data
  updateSiteData: (data) => 
    axios.put(`${API_BASE}/admin/site-data`, data, { headers: getAuthHeaders() }),
  
  // Projects
  addProject: (project) => 
    axios.post(`${API_BASE}/admin/projects`, project, { headers: getAuthHeaders() }),
  updateProject: (id, project) => 
    axios.put(`${API_BASE}/admin/projects/${id}`, project, { headers: getAuthHeaders() }),
  deleteProject: (id) => 
    axios.delete(`${API_BASE}/admin/projects/${id}`, { headers: getAuthHeaders() }),
  
  // Services
  addService: (service) => 
    axios.post(`${API_BASE}/admin/services`, service, { headers: getAuthHeaders() }),
  updateService: (id, service) => 
    axios.put(`${API_BASE}/admin/services/${id}`, service, { headers: getAuthHeaders() }),
  deleteService: (id) => 
    axios.delete(`${API_BASE}/admin/services/${id}`, { headers: getAuthHeaders() }),
  
  // Pricing
  addPricing: (plan) => 
    axios.post(`${API_BASE}/admin/pricing`, plan, { headers: getAuthHeaders() }),
  updatePricing: (id, plan) => 
    axios.put(`${API_BASE}/admin/pricing/${id}`, plan, { headers: getAuthHeaders() }),
  deletePricing: (id) => 
    axios.delete(`${API_BASE}/admin/pricing/${id}`, { headers: getAuthHeaders() }),
};

// CrushShy app admin
export const crushshyAdminApi = {
  getDashboard: () =>
    axios.get(`${API_BASE}/admin/crushshy/dashboard`, { headers: getAuthHeaders() }),
  getUsers: (params) =>
    axios.get(`${API_BASE}/admin/crushshy/users`, { headers: getAuthHeaders(), params }),
  getUser: (id) =>
    axios.get(`${API_BASE}/admin/crushshy/users/${id}`, { headers: getAuthHeaders() }),
  createUser: (user) =>
    axios.post(`${API_BASE}/admin/crushshy/users`, user, { headers: getAuthHeaders() }),
  updateUser: (id, user) =>
    axios.put(`${API_BASE}/admin/crushshy/users/${id}`, user, { headers: getAuthHeaders() }),
  deleteUser: (id) =>
    axios.delete(`${API_BASE}/admin/crushshy/users/${id}`, { headers: getAuthHeaders() }),
  getReports: (params) =>
    axios.get(`${API_BASE}/admin/crushshy/reports`, { headers: getAuthHeaders(), params }),
  updateReport: (id, data) =>
    axios.put(`${API_BASE}/admin/crushshy/reports/${id}`, data, { headers: getAuthHeaders() }),
  getSettings: () =>
    axios.get(`${API_BASE}/admin/crushshy/settings`, { headers: getAuthHeaders() }),
  updateSettings: (data) =>
    axios.put(`${API_BASE}/admin/crushshy/settings`, data, { headers: getAuthHeaders() }),
  getVerifications: (params) =>
    axios.get(`${API_BASE}/admin/crushshy/verifications`, { headers: getAuthHeaders(), params }),
  reviewVerification: (accountId, data) =>
    axios.put(`${API_BASE}/admin/crushshy/verifications/${accountId}`, data, {
      headers: getAuthHeaders(),
    }),
  getVerificationDocument: (accountId) =>
    axios.get(`${API_BASE}/admin/crushshy/verifications/${accountId}/document`, {
      headers: getAuthHeaders(),
      responseType: 'blob',
    }),
};

export default api;
